import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import * as Turbo from "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary.tsx";
import { SupabaseAuthSync } from "./components/SupabaseAuthSync.tsx";
import { registerBridgeComponents } from "./lib/bridge.ts";
import { isHotwireNative } from "./lib/native.ts";
import "./index.css";
import "./styles/native-bridge.css";

// Start Turbo for Hotwire Native compatibility
Turbo.start();

// Initialize Stimulus for bridge components
const application = Application.start();
window.Stimulus = application;

// Register bridge components for native communication
registerBridgeComponents();

// Log platform context
const platform = isHotwireNative() ? 'Hotwire Native iOS' : 'Web';
console.log(`🚀 Running on: ${platform}`);

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!clerkPublishableKey) {
  throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY environment variable");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkProvider 
      publishableKey={clerkPublishableKey}
      allowedRedirectOrigins={[
        'http://localhost:3000',
        'http://localhost:5173',
        'http://localhost:5175',
        /https:\/\/.*\.vercel\.app$/,
      ]}
    >
      <SupabaseAuthSync>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </SupabaseAuthSync>
    </ClerkProvider>
  </StrictMode>
);
